import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, Tooltip, useMediaQuery } from "@material-ui/core";
import {
  SimpleLoading,
  PromotionalFooterPure,
  DropDownBtnHLPure,
  SubtitlePageHLPure,
  DialogFormHLPure,
  DialogSystemGLPure,
  DialogYesNoHLPure,
  LabelModalPure,
} from "../../pures";
import { FilterHLPure, GridHLPure, SearchBarHLPure } from "../../pures";
import "./questionnaires-administration.view.css";
import { NIL as NIL_UUID } from "uuid";
import { useHistory, useLocation } from "react-router";

import {
  AvisoPrivacidad,
  ContratoArrendamiento,
  ContratoCompraVenta,
  ContratoLaboral,
  ContratoMutuo,
  ContratoNDA,
  ContratoServicios,
  ContratoSuministros,
  Contratos,
  QuestionnaireAdministration,
  TemplateAdministration,
  ContractAdministration,
  NewContract,
} from "../../../assets/logos/icons";
import QuestionnairesAdministrationConfigurationsView from "./questionnaires-administration-configurations-view";
import ButtonAddHLPure from "../../pures/buttonAddHL/buttonAddHL.pure";
import { profileIconDefault } from "../../../assets/logos/icons";
import { RadioButton } from "@progress/kendo-react-inputs";
import { QuestionnaireService, ContractService } from "../../../services";

const QuestionnairesAdministrationView = (props) => {
  const {
    questionnairesByUser,
    companysForUser,
    templatesForUser,
    toggleErrorRequesting,
    toggleLoadingRequesting,
    toggleCompletedRequesting,
    showCompletedRequesting,
    showLoadingRequesting,
    showErrorRequesting,
    toggleCompletedQuestionsRequesting,
    companySelectQuestionnaires,
    setCompanySelectQuestionnaires,
    filterStatusQuestionnaires,
    setFilterStatusQuestionnaires,
    getContractPersonTypes,
    changeRedirect,
    changeRoute
  } = props;
  const [dataQuestionnaires, setDataQuestionnaires] =
    useState(questionnairesByUser);
  const [stateNameComponentUser, setStateNameComponentUser] = useState("");
  const [selectedValueFilter, setSelectedValue] = useState(NIL_UUID);
  const [searchValue, setSearchValue] = useState("");
  const [searchValueCompany, setSearchValueCompany] = useState(NIL_UUID);
  const [selectedQuestionnaire, setSelectedQuestionnaire] = useState({});
  const [showDetails, setShowDetails] = useState(false);
  const [nameComponentUser, setNameComponentUser] = useState("");
  const [showDialogIcon, setShowDialogIcon] = useState(false);
  const [imageTitle, setImagetitle] = useState(null);
  const [uploadImage, setuploadImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [allInfoQuestionToSend, setAllInfoQuestionToSend] = useState([]);
  const [allInfoQuestionToSendStirng, setAllInfoQuestionToSendStirng] =
    useState("");
  const [flagToCleanDataQuestion, setFlagToCleanDataQuestion] = useState(false);
  const [showDialogDeleteQuestionnaire, setShowDialogDeleteQuestionnaire] =
    useState(false);
  const [idQuestionnaireToDelete, setIdQuestionnaireToDelete] =
    useState(NIL_UUID);
  const [descriptionDeleteQuestion, setDescriptionDeleteQuestion] =
    useState("");
  const [templates, setTemplates] = useState([]);
  const [showCompanys, setShowCompanys] = useState([]);
  const [showOptions, setShowOptions] = useState([]);
  const [errorInfoQuestions, setErrorinfoQuestions] = useState(false);
  const [questionnairesAgain, setQuestionnairesAgain] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const hideAvatar = useMediaQuery("(max-width: 1200px)");
  const hideStatus = useMediaQuery("(max-width: 1100px)");

  const [headerTitleinDetail, setHeaderTitleinDetail] = useState({
    clicked: false,
    name: "",
  });
  const [companySelected, setCompanySelected] = useState([
    {
      addressCountry: "",
      addressState: "",
      addressStreet: "",
      addressTownship: "",
      addressZipCode: "",
      businessName: "",
      companyName: "Sin asignar",
      deactivationReason: null,
      description: "",
      id: NIL_UUID,
      logo: "",
      rfc: "",
      status: false,
      turnOfTheCompany: "",
      typeOfCompany: "",
      updatedByUser: "",
    },
  ]);
  const { t } = useTranslation();
  const history = useHistory();

  let location = useLocation();
  let urlContract = location.pathname

  //Filter, information to options filter
  const options = [
    {
      active: NIL_UUID,
      status: t("digitalContractDashboard.questionnaires.main.allQuestionnaires"),
    },
    {
      active: true,
      status: t("digitalContractDashboard.questionnaires.main.activeQuestionnaires"),
    },
    {
      active: false,
      status: t("digitalContractDashboard.questionnaires.main.inactiveQuestionnaires"),
    },
  ];

  let icons = [
    {
      description: "Aviso de privacidad",
      groupIdentifier: "signatureProfile",
      id: 1,
      microserviceId: 2,
      name: "Aviso de privacidad",
      path: AvisoPrivacidad,
    },
    {
      description: "Contrato arrendamiento",
      groupIdentifier: "signatureProfile",
      id: 2,
      microserviceId: 2,
      name: "Contrato arrendamiento",
      path: ContratoArrendamiento,
    },
    {
      description: "Contrato de compraventa",
      groupIdentifier: "signatureProfile",
      id: 3,
      microserviceId: 2,
      name: "Contrato de compraventa",
      path: ContratoCompraVenta,
    },
    {
      description: "Contrato laboral",
      groupIdentifier: "signatureProfile",
      id: 4,
      microserviceId: 2,
      name: "Contrato laboral",
      path: ContratoLaboral,
    },
    {
      description: "Contrato mutuo",
      groupIdentifier: "signatureProfile",
      id: 5,
      microserviceId: 2,
      name: "Contrato mutuo",
      path: ContratoMutuo,
    },
    {
      description: "Contrato NDA",
      groupIdentifier: "signatureProfile",
      id: 6,
      microserviceId: 2,
      name: "Contrato NDA",
      path: ContratoNDA,
    },
    {
      description: "Contrato de servicios",
      groupIdentifier: "signatureProfile",
      id: 7,
      microserviceId: 2,
      name: "Contrato de servicios",
      path: ContratoServicios,
    },
    {
      description: "Contrato de suministros",
      groupIdentifier: "signatureProfile",
      id: 8,
      microserviceId: 2,
      name: "Contrato de suministros",
      path: ContratoSuministros,
    },
    {
      description: "Contratos",
      groupIdentifier: "signatureProfile",
      id: 9,
      microserviceId: 2,
      name: "Contratos",
      path: Contratos,
    },
    // {
    //   description: "Cuestionarios",
    //   groupIdentifier: "signatureProfile",
    //   id: 10,
    //   microserviceId: 2,
    //   name: "Cuestionarios",
    //   path: QuestionnaireAdministration,
    // },
    // {
    //   description: "Templates",
    //   groupIdentifier: "signatureProfile",
    //   id: 11,
    //   microserviceId: 2,
    //   name: "Templates",
    //   path: TemplateAdministration,
    // },
    // {
    //   description: "Nuevo contrato",
    //   groupIdentifier: "signatureProfile",
    //   id: 12,
    //   microserviceId: 2,
    //   name: "New Contract",
    //   path: NewContract,
    // },
    // {
    //   description: "dministracion de contratos",
    //   groupIdentifier: "signatureProfile",
    //   id: 13,
    //   microserviceId: 2,
    //   name: "ContractAdministration",
    //   path: ContractAdministration,
    // },
  ];

  //Search Function, get value search by company
  const searchChangeCompany = (e) => {
    setSearchValueCompany(e.target.value);

    //save id company t search before
    setCompanySelectQuestionnaires(e.target.value);
  };

  //Search Function, search elements by company and update grid
  useEffect(() => {
    let questionnaireCopy = [...questionnairesByUser];
    let dataUpadate = "";
    //verify if choese option Sin asignar
    if (searchValueCompany === NIL_UUID) {
      if (selectedValueFilter !== "" && searchValue === "") {
        if (selectedValueFilter === NIL_UUID) {
          dataUpadate = questionnaireCopy.filter((questionnaire) => {
            return (
              questionnaire.companyId === NIL_UUID &&
              (questionnaire.active === true || questionnaire.active === false)
            );
          });
        } else {
          dataUpadate = questionnaireCopy.filter((questionnaire) => {
            return (
              questionnaire.companyId === NIL_UUID &&
              questionnaire.active === selectedValueFilter
            );
          });
        }
      } else if (selectedValueFilter === "" && searchValue !== "") {
        dataUpadate = questionnaireCopy.filter((questionnaire) => {
          return (
            questionnaire.companyId === NIL_UUID &&
            (questionnaire.name
              .toLowerCase()
              .includes(searchValue.toLowerCase()) ||
              questionnaire.name.includes(searchValue.toLowerCase()))
          );
        });
        //verify if search input has and filter input has value
      } else if (selectedValueFilter !== "" && searchValue !== "") {
        if (selectedValueFilter !== NIL_UUID) {
          dataUpadate = questionnaireCopy.filter((questionnaire) => {
            return (
              questionnaire.companyId === NIL_UUID &&
              (questionnaire.name
                .toLowerCase()
                .includes(searchValue.toLowerCase()) ||
                questionnaire.name.includes(searchValue.toLowerCase())) &&
              (questionnaire.active === true || questionnaire.active === false)
            );
          });
        } else {
          dataUpadate = questionnaireCopy.filter((questionnaire) => {
            return (
              questionnaire.companyId === NIL_UUID &&
              (questionnaire.name
                .toLowerCase()
                .includes(searchValue.toLowerCase()) ||
                questionnaire.name.includes(searchValue.toLowerCase())) &&
              questionnaire.active === selectedValueFilter
            );
          });
        }
      } else {
        dataUpadate = questionnaireCopy.filter((questionnaire) => {
          return questionnaire.companyId === NIL_UUID;
        });
      }
    } else {
      //verify if search input has value and filter input is void
      if (selectedValueFilter !== "" && searchValue === "") {
        if (selectedValueFilter === NIL_UUID) {
          dataUpadate = questionnaireCopy.filter((questionnaire) => {
            return (
              questionnaire.companyId.indexOf(searchValueCompany) >= 0 &&
              (questionnaire.active === true || questionnaire.active === false)
            );
          });
        } else {
          dataUpadate = questionnaireCopy.filter((questionnaire) => {
            return (
              questionnaire.companyId.indexOf(searchValueCompany) >= 0 &&
              questionnaire.active === selectedValueFilter
            );
          });
        }

        //verify if search input is void and filter input has void
      } else if (selectedValueFilter === "" && searchValue !== "") {
        dataUpadate = questionnaireCopy.filter((questionnaire) => {
          return (
            questionnaire.companyId.indexOf(searchValueCompany) >= 0 &&
            (questionnaire.name
              .toLowerCase()
              .includes(searchValue.toLowerCase()) ||
              questionnaire.name.includes(searchValue.toLowerCase()))
          );
        });

        //verify if search input has and filter input has value
      } else if (selectedValueFilter !== "" && searchValue !== "") {
        if (selectedValueFilter === NIL_UUID) {
          dataUpadate = questionnaireCopy.filter((questionnaire) => {
            return (
              questionnaire.companyId.indexOf(searchValueCompany) >= 0 &&
              (questionnaire.name
                .toLowerCase()
                .includes(searchValue.toLowerCase()) ||
                questionnaire.name.includes(searchValue.toLowerCase())) &&
              (questionnaire.active === true || questionnaire.active === false)
            );
          });
        } else {
          dataUpadate = questionnaireCopy.filter((questionnaire) => {
            return (
              questionnaire.companyId.indexOf(searchValueCompany) >= 0 &&
              (questionnaire.name
                .toLowerCase()
                .includes(searchValue.toLowerCase()) ||
                questionnaire.name.includes(searchValue.toLowerCase())) &&
              questionnaire.active === selectedValueFilter
            );
          });
        }
      } else {
        dataUpadate = questionnaireCopy.filter((questionnaire) => {
          return questionnaire.companyId.indexOf(searchValueCompany) >= 0;
        });
      }
    }

    setDataQuestionnaires(dataUpadate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValueCompany]);

  //Filter Function, convert to boolean
  const strToboolean = (value) => {
    if (value && typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
    }
    return value;
  };

  //Filter Function, get selected value
  const filterChange = (e) => {
    const selectedOption = strToboolean(e.target.value);
    setSelectedValue(selectedOption);
    //set option to search before
    setFilterStatusQuestionnaires(selectedOption);
  };

  //Update state information from grid
  useEffect(() => {
    if (questionnairesByUser && companysForUser && options) {
      setDataQuestionnaires(questionnairesByUser);
      setShowCompanys(companysForUser);
      setShowOptions(options);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionnairesByUser, companysForUser]);

  //Filter Function, filter elements and update grid
  useEffect(() => {
    let questionnaireCopy = [...questionnairesByUser];
    let dataUpadate = "";

    //verify if search company input has and search input is void
    if (searchValueCompany !== "" && searchValue === "") {
      if (searchValueCompany === NIL_UUID) {
        if (selectedValueFilter === NIL_UUID) {
          dataUpadate = questionnaireCopy.filter(
            (questionnaire) =>
              (questionnaire.active === true ||
                questionnaire.active === false) &&
              questionnaire.companyId === NIL_UUID
          );
        } else {
          dataUpadate = questionnaireCopy.filter(
            (questionnaire) =>
              questionnaire.active === selectedValueFilter &&
              questionnaire.companyId === NIL_UUID
          );
        }
      } else {
        if (selectedValueFilter === NIL_UUID) {
          dataUpadate = questionnaireCopy.filter(
            (questionnaire) =>
              (questionnaire.active === true ||
                questionnaire.active === false) &&
              questionnaire.companyId.indexOf(searchValueCompany) >= 0
          );
        } else {
          dataUpadate = questionnaireCopy.filter(
            (questionnaire) =>
              questionnaire.active === selectedValueFilter &&
              questionnaire.companyId.indexOf(searchValueCompany) >= 0
          );
        }
      }

      //verify if search company input is void and search input has value
    } else if (searchValueCompany === "" && searchValue !== "") {
      if (selectedValueFilter === NIL_UUID) {
        dataUpadate = questionnaireCopy.filter(
          (questionnaire) =>
            (questionnaire.active === true || questionnaire.active === false) &&
            questionnaire.name.indexOf(searchValue) >= 0
        );
      } else {
        if (selectedValueFilter === NIL_UUID) {
          dataUpadate = questionnaireCopy.filter(
            (questionnaire) =>
              (questionnaire.active === true ||
                questionnaire.active === false) &&
              questionnaire.name.indexOf(searchValue) >= 0
          );
        } else {
          if (selectedValueFilter === NIL_UUID) {
            dataUpadate = questionnaireCopy.filter(
              (questionnaire) =>
                (questionnaire.active === true ||
                  questionnaire.active === false) &&
                questionnaire.name.indexOf(searchValue) >= 0
            );
          } else {
            dataUpadate = questionnaireCopy.filter(
              (questionnaire) =>
                questionnaire.active === selectedValueFilter &&
                questionnaire.name.indexOf(searchValue) >= 0
            );
          }
        }
      }

      //verify if search company input has value and search input has value
    } else if (searchValueCompany !== "" && searchValue !== "") {
      if (searchValueCompany === NIL_UUID) {
        if (selectedValueFilter === NIL_UUID) {
          dataUpadate = questionnaireCopy.filter(
            (questionnaire) =>
              (questionnaire.active === true ||
                questionnaire.active === false) &&
              questionnaire.name.indexOf(searchValue) >= 0 &&
              questionnaire.companyId === NIL_UUID
          );
        } else {
          dataUpadate = questionnaireCopy.filter(
            (questionnaire) =>
              questionnaire.active === selectedValueFilter &&
              questionnaire.name.indexOf(searchValue) >= 0 &&
              questionnaire.companyId === NIL_UUID
          );
        }
      } else {
        if (selectedValueFilter === NIL_UUID) {
          dataUpadate = questionnaireCopy.filter(
            (questionnaire) =>
              (questionnaire.active === true ||
                questionnaire.active === false) &&
              questionnaire.name.indexOf(searchValue) >= 0 &&
              questionnaire.companyId.indexOf(searchValueCompany) >= 0
          );
        } else {
          dataUpadate = questionnaireCopy.filter(
            (questionnaire) =>
              questionnaire.active === selectedValueFilter &&
              questionnaire.name.indexOf(searchValue) >= 0 &&
              questionnaire.companyId.indexOf(searchValueCompany) >= 0
          );
        }
      }
    } else {
      if (selectedValueFilter === NIL_UUID) {
        dataUpadate = questionnaireCopy.filter(
          (questionnaire) =>
            questionnaire.active === true || questionnaire.active === false
        );
      } else {
        dataUpadate = questionnaireCopy.filter(
          (questionnaire) => questionnaire.active === selectedValueFilter
        );
      }
    }
    setDataQuestionnaires(dataUpadate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValueFilter]);

  //Search Function, get value search input
  const searchChange = (e) => {
    setSearchValue(e.target.value);
  };

  //Search Function, search elements and update grid
  useEffect(() => {
    let questionnaireCopy = [...questionnairesByUser];
    let dataUpadate = "";

    //verify if search company input has and filter input is void
    if (searchValueCompany !== "" && selectedValueFilter === "") {
      if (searchValueCompany === NIL_UUID) {
        dataUpadate = questionnaireCopy.filter((questionnaire) => {
          return (
            (questionnaire.name
              .toLowerCase()
              .includes(searchValue.toLowerCase()) ||
              questionnaire.name.includes(searchValue.toLowerCase())) &&
            questionnaire.companyId === NIL_UUID
          );
        });
      } else {
        dataUpadate = questionnaireCopy.filter((questionnaire) => {
          return (
            (questionnaire.name
              .toLowerCase()
              .includes(searchValue.toLowerCase()) ||
              questionnaire.name.includes(searchValue.toLowerCase())) &&
            questionnaire.companyId.indexOf(searchValueCompany) >= 0
          );
        });
      }
      //verify if search company input is void and filter input has value
    } else if (searchValueCompany === "" && selectedValueFilter !== "") {
      if (selectedValueFilter === NIL_UUID) {
        dataUpadate = questionnaireCopy.filter((questionnaire) => {
          return (
            (questionnaire.name
              .toLowerCase()
              .includes(searchValue.toLowerCase()) ||
              questionnaire.name.includes(searchValue.toLowerCase())) &&
            (questionnaire.active === true || questionnaire.active === false)
          );
        });
      } else {
        dataUpadate = questionnaireCopy.filter((questionnaire) => {
          return (
            (questionnaire.name
              .toLowerCase()
              .includes(searchValue.toLowerCase()) ||
              questionnaire.name.includes(searchValue.toLowerCase())) &&
            questionnaire.active === selectedValueFilter
          );
        });
      }

      //verify if search company input has value and filter input has value
    } else if (searchValueCompany !== "" && selectedValueFilter !== "") {
      if (searchValueCompany === NIL_UUID) {
        if (selectedValueFilter === NIL_UUID) {
          dataUpadate = questionnaireCopy.filter((questionnaire) => {
            return (
              (questionnaire.name
                .toLowerCase()
                .includes(searchValue.toLowerCase()) ||
                questionnaire.name.includes(searchValue.toLowerCase())) &&
              questionnaire.companyId === NIL_UUID &&
              (questionnaire.active === true || questionnaire.active === false)
            );
          });
        } else {
          dataUpadate = questionnaireCopy.filter((questionnaire) => {
            return (
              (questionnaire.name
                .toLowerCase()
                .includes(searchValue.toLowerCase()) ||
                questionnaire.name.includes(searchValue.toLowerCase())) &&
              questionnaire.companyId === NIL_UUID &&
              questionnaire.active === selectedValueFilter
            );
          });
        }
      } else {
        if (selectedValueFilter === NIL_UUID) {
          dataUpadate = questionnaireCopy.filter((questionnaire) => {
            return (
              (questionnaire.name
                .toLowerCase()
                .includes(searchValue.toLowerCase()) ||
                questionnaire.name.includes(searchValue.toLowerCase())) &&
              questionnaire.companyId.indexOf(searchValueCompany) >= 0 &&
              (questionnaire.active === true || questionnaire.active === false)
            );
          });
        } else {
          dataUpadate = questionnaireCopy.filter((questionnaire) => {
            return (
              (questionnaire.name
                .toLowerCase()
                .includes(searchValue.toLowerCase()) ||
                questionnaire.name.includes(searchValue.toLowerCase())) &&
              questionnaire.companyId.indexOf(searchValueCompany) >= 0 &&
              questionnaire.active === selectedValueFilter
            );
          });
        }
      }
    } else {
      dataUpadate = questionnaireCopy.filter((questionnaire) => {
        return questionnaire.name.indexOf(searchValue) >= 0;
      });
    }
    setDataQuestionnaires(dataUpadate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  const setHeaderTitle = () => {
    const name = headerTitleinDetail.name || nameComponentUser;
    switch (name) {
      case "":
        return t("questionnariesAdministrationView.title");
      case t("questionnairesAdministrationView.btn.adm.questions.grid"):
        return t("questionnairesAdministrationView.admin.questionnaire.title");
      case "Ver detalle":
        return t("questionnairesAdministrationView.see.detail.title");
      case t("questionnairesAdministrationEditDetailView.btn.add.questionnaire"):
        return t("questionnairesAdministrationView.add.questionnaire.title");
      case t("questionnairesAdministrationEditDetailView.btn.duplicate.questionnaire"):
        return t(
          "questionnairesAdministrationEditDetailView.btn.duplicate.questionnaire"
        );
      case t("questionnairesAdministrationEditDetailView.btn.edit.question"):
        return t("questionnairesAdministrationView.header.title.edit.question");
      case t("questionnairesAdministrationView.header.title.add.question"):
        return t("questionnairesAdministrationView.header.title.add.question");
      case t("questionnairesAdministrationView.header.title.delete.question"):
        return t(
          "questionnairesAdministrationView.header.title.delete.question"
        );
      case t("questionnairesAdministrationView.grid.disable"):
        return t(
          "questionnairesAdministrationView.header.title.disable.question"
        );
      default:
        return t("questionnariesAdministrationView.title");
    }
  };

  useEffect(() => {
    if (headerTitleinDetail.clicked) {
      setHeaderTitle();
    }
    setHeaderTitle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameComponentUser, headerTitleinDetail]);

  //first search
  useEffect(() => {
    if (!questionnairesByUser) {
      return;
    }
    setQuestionnairesAgain(questionnairesByUser);
    let questionnaireCopy = questionnairesByUser
      ? [...questionnairesByUser]
      : [];
    let dataUpadate = questionnaireCopy.filter((questionnaire) => {
      return (
        questionnaire.companyId.indexOf(NIL_UUID) >= 0 &&
        (questionnaire.active === true || questionnaire.active === false)
      );
    });
    setDataQuestionnaires(dataUpadate);
    if (props.standardContract) {
      setNameComponentUser(t("questionnairesAdministrationEditDetailView.btn.add.questionnaire"))
      setShowDetails(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionnairesByUser]);

  useEffect(() => {
    let companyInfo = companysForUser.filter((company) => {
      return company.id === searchValueCompany;
    });
    setCompanySelected(companyInfo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValueCompany]);

  const toggleDialogIcon = () => {
    setShowDialogIcon(!showDialogIcon);
  };

  const uploadFile = () => {
    setShowDialogIcon(!showDialogIcon);
  };

  //Delete icon, cancel btn
  const onCancelIcon = () => {
    toggleDialogIcon();
    setImagetitle(null);
    setuploadImage(null);
  };

  //save icon
  const onSaveImg = (e) => {
    e.preventDefault();
    toggleDialogIcon();
    setuploadImage(imageTitle);
  };

  //it call service to save all informatio about questionnaire
  useEffect(() => {
    if (allInfoQuestionToSendStirng !== "") {
      saveInfoQuestions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allInfoQuestionToSendStirng]);

  //function to send allInfo
  const saveInfoQuestions = async () => {
    try {
      let questionnaireService = new QuestionnaireService(
        process.env.REACT_APP_MIFIRMA_API
      );
      let questionSave = await questionnaireService.updateQuestions(
        allInfoQuestionToSendStirng,
        props.token
      );

      if (questionSave && Number(questionSave.statusCode) === 200) {
        if (
          nameComponentUser === t("questionnairesAdministrationEditDetailView.btn.edit.question") ||
          nameComponentUser === t("questionnairesAdministrationView.header.title.add.question") ||
          nameComponentUser === t("questionnairesAdministrationView.header.title.delete.question")
        ) {
          await toggleLoadingRequesting(false);
          await toggleCompletedQuestionsRequesting(true);
        }
        setNameComponentUser(
          t("questionnairesAdministrationView.btn.adm.questions.grid") ||
          nameComponentUser === t("questionnairesAdministrationView.header.title.add.question") ||
          nameComponentUser === t("questionnairesAdministrationView.header.title.delete.question")
        );
        setTimeout(() => {
          setShowDetails(true);
          toggleCompletedQuestionsRequesting(false);
        }, 500);
      } else {
        setErrorinfoQuestions(true);
        if (
          nameComponentUser === t("questionnairesAdministrationEditDetailView.btn.edit.question") ||
          nameComponentUser === t("questionnairesAdministrationView.header.title.add.question") ||
          nameComponentUser === t("questionnairesAdministrationView.header.title.delete.question")
        ) {
          await toggleLoadingRequesting(false);
          await toggleErrorRequesting(true);
          setTimeout(() => {
            toggleErrorRequesting(false);
          }, 2000);
        }
      }
    } catch (error) {
      setErrorinfoQuestions(true);
      if (nameComponentUser === t("questionnairesAdministrationEditDetailView.btn.edit.question")) {
        await toggleLoadingRequesting(false);
        await toggleErrorRequesting(true);
        setTimeout(() => {
          toggleErrorRequesting(false);
        }, 2000);
      }
    }
  };

  //open  modal
  const openShowDialogDeleteQuestionnaire = (dataItem) => {
    setShowDialogDeleteQuestionnaire(true);
    setIdQuestionnaireToDelete(dataItem.id);
  };

  const closeShowDialogDeleteQuestionnaire = () => {
    setShowDialogDeleteQuestionnaire(false);
  };

  //delete questionnaire
  const handleDeleteQuestionnaire = async () => {
    closeShowDialogDeleteQuestionnaire(false);
    await toggleLoadingRequesting(true);
    let userId = props.user.userMetaData.userA3Cloud.clientId;
    let id = idQuestionnaireToDelete ? idQuestionnaireToDelete : NIL_UUID;
    try {
      let questionnaireService = new QuestionnaireService(
        process.env.REACT_APP_MIFIRMA_API
      );
      let contractService = new ContractService(
        process.env.REACT_APP_MIFIRMA_API
      );

      let questionnaireDeleted = await questionnaireService.deleteQuestionnaire(
        id,
        props.token
      );

      if (
        questionnaireDeleted &&
        Number(questionnaireDeleted.statusCode) === 200
      ) {
        let questionnaires = await contractService.getQuestionnairesByUserId(
          props.token,
          userId
        );
        await toggleLoadingRequesting(false);
        await toggleCompletedRequesting(true, "", questionnaires.data.data);
        setTimeout(() => {
          setShowDetails(false);
          setNameComponentUser("");
          setHeaderTitleinDetail({ clicked: false, name: "" });
        }, 4000);
      } else if (Number(questionnaireDeleted.statusCode) === -3) {
        setErrorMessage("El cuestionario tiene un contrato asociado");
        await toggleLoadingRequesting(false);
        await toggleErrorRequesting(true);
        setTimeout(() => {
          toggleErrorRequesting(false);
        }, 2000);
      } else if (Number(questionnaireDeleted.statusCode) === -5) {
        setErrorMessage("El cuestionario no existe");
        await toggleLoadingRequesting(false);
        await toggleErrorRequesting(true);
        setTimeout(() => {
          toggleErrorRequesting(false);
        }, 2000);
      } else {
        setErrorMessage(
          "Ocurrió un error al eliminar el cuestionario, intente nuevamente"
        );
        await toggleLoadingRequesting(false);
        await toggleErrorRequesting(true);
        setTimeout(() => {
          toggleErrorRequesting(false);
        }, 2000);
      }
    } catch (error) {
      await toggleLoadingRequesting(false);
      await toggleErrorRequesting(true);
      setTimeout(() => {
        toggleErrorRequesting(false);
      }, 2000);
    }
  };

  const getTemplates = async () => {
    let clientId = props.user.userMetaData.userA3Cloud.clientId;
    let questionnaireService = new QuestionnaireService(
      process.env.REACT_APP_MIFIRMA_API
    );
    let allTemplates =
      await questionnaireService.getAllTemplatesByCompaniIdAndClienId(
        clientId,
        "",
        props.token
      );
    if (allTemplates && allTemplates.data && Number(allTemplates.data.statusCode) === 200) {
      let templatesActives = allTemplates.data.data.filter((template) => template.active === true && template.name !== '')
      setTemplates(templatesActives);
    }
  };

  useEffect(() => {
    if (props.user && props.user.userMetaData) {
      getTemplates();
    }
  }, [props.user]);

  //Select dataGrid by company or filter if was selected previosly
  useEffect(() => {
    let questionnaireCopy = [...questionnairesByUser];
    let dataUpadate = "";
    let companysNew = [];
    let optionsNew = [];
    let option = {};
    if (companySelectQuestionnaires) {
      //set company to drop
      let companyAdd = companysForUser.filter(
        (company) => company.id === companySelectQuestionnaires
      );
      companysNew = companysForUser.filter(
        (company) => company.id !== companySelectQuestionnaires
      );
      companysNew.unshift(companyAdd[0]);

      //set filter options to filter
      if (filterStatusQuestionnaires !== NIL_UUID) {
        option = options.filter(
          (option) => option.active === filterStatusQuestionnaires
        );
        optionsNew = options.filter(
          (option) =>
            option.active !== filterStatusQuestionnaires ||
            option.active === NIL_UUID
        );
        optionsNew.unshift(option[0]);
        setShowOptions(optionsNew);
      } else {
        setShowOptions(options);
      }

      if (
        companySelectQuestionnaires === NIL_UUID &&
        filterStatusQuestionnaires === NIL_UUID
      ) {
        dataUpadate = questionnaireCopy.filter(
          (questionnaire) =>
            questionnaire.companyId === NIL_UUID &&
            (questionnaire.active === true || questionnaire.active === true)
        );
      } else if (
        companySelectQuestionnaires !== NIL_UUID &&
        filterStatusQuestionnaires === NIL_UUID
      ) {
        dataUpadate = questionnaireCopy.filter(
          (questionnaire) =>
            (questionnaire.companyId === companySelectQuestionnaires &&
              questionnaire.active === true) ||
            (questionnaire.companyId === companySelectQuestionnaires &&
              questionnaire.active === false)
        );
      } else if (
        companySelectQuestionnaires === NIL_UUID &&
        filterStatusQuestionnaires !== NIL_UUID
      ) {
        dataUpadate = questionnaireCopy.filter(
          (questionnaire) =>
            questionnaire.companyId === NIL_UUID &&
            questionnaire.active === filterStatusQuestionnaires
        );
      } else {
        dataUpadate = questionnaireCopy.filter(
          (questionnaire) =>
            questionnaire.companyId === companySelectQuestionnaires &&
            questionnaire.active === filterStatusQuestionnaires
        );
      }

      setShowCompanys(companysNew);
      setDataQuestionnaires(dataUpadate);
    }
  }, [showDetails, showDialogDeleteQuestionnaire]);

  const handleBackPage = () => {
    let path = (location.pathname) ? location.pathname.split('/')[1] : null
    if (path && path === 'digital-contract') {
      changeRoute(0)
    } else {
      history.goBack()
    }
  }

  return (
    <div className="questionnairesDigitalContractView-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <div>
          <DialogSystemGLPure
            toggleLoadingRequesting={toggleLoadingRequesting}
            showLoadingRequesting={showLoadingRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            message={errorMessage}
            showErrorRequesting={showErrorRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            showCompletedRequesting={showCompletedRequesting}
          />
          <Grid container xs={12} lg={12} md={12} sm={12} es={12}>
            {/**Container actions header**/}
            <Grid
              item
              lg={12}
              md={12}
              xs={12}
              sm={12}
              className="questionnairesDigitalContractView-header"
            >
              {/* {nameComponentUser === "Ver detalle" ||
                nameComponentUser === "Agregar-cuestionario" ? (
                <SubtitlePageHLPure
                  profileImg={imageTitle ? imageTitle : profileIconDefault}
                  imgProfile={profileIconDefault}
                  subtitle={setHeaderTitle()}
                  tooltipShow
                  titleTooltip={""}
                  descriptionTooltip={""}
                  uploadFile={uploadFile}
                  informationIcon={false}
                  altCustomImg={"info img"}
                  justShowImg={false}
                  changeImgFile={toggleDialogIcon}
                />
              ) : (
                <SubtitlePageHLPure
                  profileImg={""}
                  subtitle={setHeaderTitle()}
                  tooltipShow={false}
                  informationIcon={false}
                  altCustomImg={"info img"}
                />
              )} */}
            </Grid>
            {/**Container actions grid**/}
            <Grid
              container
              className="questionnairesDigitalContractView-body"
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
            >
              {showDetails && nameComponentUser ? (
                <QuestionnairesAdministrationConfigurationsView
                  standardContract={props.standardContract}
                  changeRedirect={changeRedirect}
                  nameComponentUser={nameComponentUser}
                  selectedQuestionnaire={selectedQuestionnaire}
                  companySelected={companySelected}
                  hideShowDetails={() => {
                    setShowDetails(false);
                    setNameComponentUser("");
                    setHeaderTitleinDetail({ clicked: false, name: "" });
                  }}
                  {...props}
                  token={props.token}
                  user={props.user}
                  setHeaderTitleinDetail={setHeaderTitleinDetail}
                  setNameComponentUser={setNameComponentUser}
                  setShowDetails={setShowDetails}
                  setImagetitle={setImagetitle}
                  forceRefresh={props.forceRefresh}
                  imageTitle={imageTitle}
                  companysForUser={companysForUser}
                  templatesForUser={templatesForUser}
                  allInfoQuestionToSend={allInfoQuestionToSend}
                  setAllInfoQuestionToSend={setAllInfoQuestionToSend}
                  toggleErrorRequesting={toggleErrorRequesting}
                  toggleLoadingRequesting={toggleLoadingRequesting}
                  toggleCompletedRequesting={toggleCompletedRequesting}
                  showCompletedRequesting={showCompletedRequesting}
                  showErrorRequesting={showErrorRequesting}
                  showLoadingRequesting={showLoadingRequesting}
                  stateNameComponentUser={stateNameComponentUser}
                  setStateNameComponentUser={setStateNameComponentUser}
                  allInfoQuestionToSendStirng={allInfoQuestionToSendStirng}
                  setAllInfoQuestionToSendStirng={
                    setAllInfoQuestionToSendStirng
                  }
                  flagToCleanDataQuestion={flagToCleanDataQuestion}
                  setFlagToCleanDataQuestion={setFlagToCleanDataQuestion}
                  setTemplates={setTemplates}
                  templates={templates}
                  errorInfoQuestions={errorInfoQuestions}
                  setErrorinfoQuestions={setErrorinfoQuestions}
                  toggleCompletedQuestionsRequesting={
                    toggleCompletedQuestionsRequesting
                  }
                  getContractPersonTypes={getContractPersonTypes}
                  changeRoute={changeRoute}
                  icons={icons}
                />
              ) : (
                <>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="questionnairesDigitalContractView-navbar"
                  >
                    <div className="questionnairesAdministrationView-add-button">
                      <ButtonAddHLPure
                        iconAdd={true}
                        nameBtn={t(
                          "questionnariesAdministrationView.buttonTitle"
                        )}
                        onClickBtn={() => {
                          setNameComponentUser(t("questionnairesAdministrationEditDetailView.btn.add.questionnaire"));
                          setShowDetails(true);
                        }}
                      />
                    </div>
                    <div className="questionnairesAdministrationView-seach-input-btn">
                      <SearchBarHLPure
                        placeholder={t(
                          "questionnairesAdministrationView.seacrh.placeholder"
                        )}
                        onSearchChange={(e) => searchChange(e)}
                        searchValue={searchValue}
                      />
                    </div>

                    <div className="questionnairesAdministrationView-search-filter-btn">
                      <FilterHLPure
                        options={showOptions}
                        nameOption="status"
                        valueItem="active"
                        onFilterChange={(event) => filterChange(event)}
                      />
                    </div>
                  </Grid>
                  <Grid
                    item
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="questionnairesDigitalContractView-company-search"
                  >
                    <DropDownBtnHLPure
                      labelDropDown={t(
                        "questionnairesAdministrationView.seacrh.company.label"
                      )}
                      optionsDropDown={showCompanys}
                      onDropDownChange={(event) => searchChangeCompany(event)}
                      valueItem="id"
                      nameOption="companyName"
                    />
                  </Grid>
                  <GridHLPure
                    dataGrid={dataQuestionnaires}
                    skip={0}
                    take={5}
                    titleRow1={t("questionnairesAdministrationView.grid.questionnaires")}
                    titleRow4={t(
                      "questionnairesAdministrationView.accions.title.grid"
                    )}
                    fieldRow1={"name"}
                    textSubtitle={
                      !hideAvatar
                        ? t(
                          "questionnairesAdministrationView.subtitle.grid.last.modfication"
                        )
                        : null
                    }
                    fieldSubtitle={!hideAvatar ? "updatedDate" : null}
                    fieldImg={"logo"}
                    onFilterChange={filterChange}
                    onSelectedItem={setSelectedQuestionnaire}
                    setShowDetails={setShowDetails}
                    setNameComponentUser={setNameComponentUser}
                    selectedValueFilter={selectedValueFilter}
                    title2Status={t("questionnairesAdministrationView.grid.status")}
                    column2Status={!hideStatus ? true : false}
                    field2Status={"active"}
                    columnThree={false}
                    iconOneActive
                    iconTwoActive
                    iconThirdActive
                    iconFourthActive
                    iconTrashActive
                    labelOneActions={t("questionnairesAdministrationView.grid.assign.categories")}
                    labelTrashActions={t("questionnairesAdministrationView.grid.delete")}
                    labelThirdActions={t("questionnairesAdministrationView.grid.disable")}
                    labelTwoActions={t(
                      "questionnairesAdministrationView.btn.adm.questions.grid"
                    )}
                    labelFourthActions={t("questionnairesAdministrationView.grid.detail")}
                    widthHeader={"questionnairesAdministrationView-styleHeader1"}
                    styleCol1={
                      "questionnairesAdministrationView-cellItemStyleCol1"
                    }
                    widthHeaderCol2={"questionnairesAdministrationView-styleHeader2"}
                    styleCol2={
                      "questionnairesAdministrationView-cellItemStyleCol2"
                    }
                    // styleCol3 = {"gridHLPure-cellItemStyleCol3"}
                    widthHeaderCol4={"questionnairesAdministrationView-styleHeader4"}
                    styleCol4={
                      "questionnairesAdministrationView-cellItemStyleCol4"
                    }
                    iconAvatar={!hideAvatar}
                    columnFour={true}
                    activeDialogTrash={true}
                    btnOpenDialogTrash={(dataItem) =>
                      openShowDialogDeleteQuestionnaire(dataItem)
                    }
                    onlyText={!hideAvatar}
                  />
                </>
              )}
              {showDialogIcon && (
                <DialogFormHLPure
                  cancel={onCancelIcon}
                  titleDialog={t(
                    "dialogSignRequestPure.titleDialogSignRequest"
                  )}
                  descriptionActive={true}
                  descriptionDialog={t(
                    "questionnairesAdministrationView.dialog.choose.icon.description"
                  )}
                  textBtnCancel={t("button.cancel")}
                  saveBtn={t("button.save")}
                  handleSubmit={(event) => onSaveImg(event)}
                // loadingComponent={isLoading}
                >
                  <div
                    className="signatureProfilesDetailsView-container-gallery"
                    sm={12}
                    xs={12}
                    lg={12}
                    md={12}
                  >
                    {icons.map((item, index) => (
                      <div className="signatureProfilesDetailsView-container-icons">
                        <RadioButton
                          className="signatureProfilesDetailsView-radioBtn-img"
                          name="icon"
                          value={item.path}
                          checked={imageTitle === item.path}
                          onChange={({ value }) => setImagetitle(value)}
                        />
                        <img
                          src={item.path}
                          {...item}
                          className="icon-style"
                          key={index}
                        />
                      </div>
                    ))}
                  </div>
                </DialogFormHLPure>
              )}
              {/* {!nameComponentUser &&
                <Grid
                  container
                  style={{ justifyContent: "flex-end" }}
                >
                  <ButtonHLPure
                    nameBtn={t("button.return")}
                    onClickBtn={() => handleBackPage()}
                  />
                </Grid>
              } */}

              {showDialogDeleteQuestionnaire && (
                <DialogYesNoHLPure
                  cancel={closeShowDialogDeleteQuestionnaire}
                  textBtnCancel={t("button.cancel")}
                  saveBtn={t("button.delete")}
                  titleDialog={t(
                    "dialogSignRequestPure.titleDialogSignRequest"
                  )}
                  loadingComponent={isLoading}
                  handleSubmit={handleDeleteQuestionnaire}
                >
                  <div className="questionnairesAdministrationView-delete-questionnaire">
                    <LabelModalPure label={t("questionnairesAdministrationView-dialog-delete-questionnaire-description")} />
                  </div>
                </DialogYesNoHLPure>
              )}
            </Grid>
          </Grid>
        </div>
      )}
    </div>
  );
};

export default QuestionnairesAdministrationView;